<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';

  const LIMITE_BUSCA = 200;

  const TIPOS = [
    { sigla: 'SP', nome: 'Pagamento' },
    { sigla: 'SB', nome: 'Bolsa' },
    { sigla: 'SR', nome: 'Reembolso' },
    { sigla: 'SD', nome: 'Diárias' },
  ];

  const PREFIXO = /^\s*S\s*([PBDR])\s*[.\-]?\s*(\d*)\s*$/i;

  function arredondar(v) {
    return Math.round((+v || 0) * 100) / 100;
  }

  function lerNumero(texto) {
    const limpo = (texto || '').toString().trim().replace(/\./g, '').replace(',', '.');
    if (!limpo) return 0;
    const numero = +limpo;
    return isNaN(numero) ? 0 : numero;
  }

  export default {
    components: { DatePicker },
    props: {
      value: { type: Object, default: null },
      total: { type: Number, default: 0 },
      sugestoes: { type: Array, default: () => [] },
      invalido: { type: Boolean, default: false },
      idContaCript: { type: String, default: '' },
    },
    data() {
      return {
        aberto: false,
        carregando: false,
        erro: '',
        lista: null,
        escolhida: null,
        detalhe: null,
        carregandoDetalhe: false,
        erroDetalhe: '',
        tipos: TIPOS,
        filtro: { tipo: 'SP', busca: '', dataIni: null, dataFim: null },
        temporizador: null,
        pedido: 0,
        pedidoDetalhe: 0,
        ci: null,
      }
    },
    computed: {
      sugestoesBusca() {
        const lista = [];
        (this.sugestoes || []).forEach(s => {
          const t = (s || '').toString().trim();
          if (t && lista.indexOf(t) < 0) lista.push(t);
        });
        return lista;
      },
      noLimite() { return (this.lista || []).length >= LIMITE_BUSCA; },
      siglaValor() { return (this.value && this.value.tipoSolicitacao) || 'SP'; },
      rotuloTipo() { return this.filtro.tipo ? 'da ' + this.filtro.tipo : 'da solicitação'; },
      podeBuscar() {
        if (!this.filtro.tipo) return false;
        const busca = this.filtro.busca.trim();
        return /^\s*(s\s*[pbdr]\s*[.\-]?\s*)?\d+\s*$/i.test(busca) || busca.length >= 3
          || !!this.filtro.dataIni || !!this.filtro.dataFim;
      },
      linhas() { return (this.value && this.value.linhas) || []; },
      distribuido() { return arredondar(this.linhas.reduce((s, l) => s + (+l.valor || 0), 0)); },
      falta() { return arredondar(this.total - this.distribuido); },
      linhasAcimaDoSaldo() { return this.linhas.filter(l => (+l.valor || 0) > (+l.saldo || 0) + 0.005); },
      temItem() { return this.linhas.some(l => l.idProjetoItemControle > 0); },
      linhasSemQuantidade() { return this.linhas.filter(l => this.faltaQuantidade(l)); },
    },
    watch: {
      total(novo, antigo) {
        if (!this.value || arredondar(novo) === arredondar(antigo)) return;
        const comSaldo = this.linhas.filter(l => (+l.saldo || 0) > 0);
        this.linhas.forEach(l => {
          l.valor = comSaldo.length === 1 && comSaldo[0] === l ? arredondar(Math.min(novo, +l.saldo || 0)) : 0;
          l.valorTexto = l.valor > 0 ? this.formatar(l.valor) : '';
          this.ajustarQuantidade(l);
        });
        this.emitir();
      },
      'filtro.busca'(busca) {
        const prefixo = PREFIXO.exec(busca || '');
        if (prefixo) this.filtro.tipo = 'S' + prefixo[1].toUpperCase();
      },
      'filtro.tipo'() {
        this.pedidoDetalhe++;
        this.escolhida = null;
        this.detalhe = null;
        this.carregandoDetalhe = false;
      },
      filtro: {
        deep: true,
        handler() {
          if (!this.aberto) return;
          clearTimeout(this.temporizador);
          if (!this.podeBuscar) {
            this.pedido++;
            this.carregando = false;
            this.lista = null;
            return;
          }
          this.temporizador = setTimeout(() => this.buscar(), 400);
        },
      },
    },
    beforeDestroy() {
      clearTimeout(this.temporizador);
    },
    methods: {
      formatar(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      formatarQuantidade(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
      },
      abrir() {
        this.lista = null;
        this.erro = '';
        this.detalhe = null;
        this.escolhida = null;
        const inicial = this.sugestoesBusca[0] || '';
        const prefixo = PREFIXO.exec(inicial);
        const tipoAtual = this.value && this.value.tipoSolicitacao;
        this.filtro = { tipo: prefixo ? 'S' + prefixo[1].toUpperCase() : (tipoAtual || null), busca: inicial, dataIni: null, dataFim: null };
        this.aberto = true;
        if (this.podeBuscar) this.buscar();
        this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
      },
      fechar() {
        clearTimeout(this.temporizador);
        this.aberto = false;
      },
      sugestaoAtiva(s) {
        return this.filtro.busca.trim().toUpperCase() === s.toUpperCase();
      },
      alternarSugestao(s) {
        this.filtro.busca = this.sugestaoAtiva(s) ? '' : s;
      },
      limparFiltros() {
        this.filtro = { tipo: this.filtro.tipo, busca: '', dataIni: null, dataFim: null };
      },
      escolherTipo(sigla) {
        if (this.filtro.tipo === sigla) return;
        const prefixo = PREFIXO.exec(this.filtro.busca || '');
        if (prefixo) this.filtro.busca = prefixo[2] || '';
        this.filtro.tipo = sigla;
        this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
      },
      buscarAgora() {
        clearTimeout(this.temporizador);
        if (this.podeBuscar) this.buscar();
      },
      enterNoFiltro(e) {
        if (!e.target || e.target.tagName !== 'INPUT') return;
        e.preventDefault();
        e.stopPropagation();
        this.buscarAgora();
      },
      buscar() {
        const pedido = ++this.pedido;
        const f = this.filtro;

        this.carregando = true;
        this.erro = '';

        conciliacaoProjetoServico.solicitacoesDevolucao({
          tipo: f.tipo,
          busca: f.busca.trim(),
          dataIni: f.dataIni ? moment(f.dataIni).format('YYYY-MM-DD') : '',
          dataFim: f.dataFim ? moment(f.dataFim).format('YYYY-MM-DD') : '',
          valor: this.total ? this.total.toFixed(2) : '',
        })
          .then(lista => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.lista = lista || [];
            if (this.escolhida && !this.lista.some(sp => sp.idSolicitacao === this.escolhida.idSolicitacao)) {
              this.pedidoDetalhe++;
              this.escolhida = null;
              this.detalhe = null;
              this.carregandoDetalhe = false;
            }
            if (this.lista.length && this.lista[0].numeroConfere && !this.escolhida) this.escolher(this.lista[0]);
          })
          .catch(res => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível buscar as solicitações.';
          });
      },
      escolher(sp) {
        this.escolhida = sp;
        const pedido = ++this.pedidoDetalhe;

        this.carregandoDetalhe = true;
        this.erroDetalhe = '';
        this.detalhe = null;

        conciliacaoProjetoServico.solicitacaoDevolucao(sp.idSolicitacao, this.idContaCript, sp.tipoSolicitacao || this.filtro.tipo)
          .then(detalhe => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.detalhe = detalhe;
          })
          .catch(res => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.erroDetalhe = (res && res.body && res.body.message) || 'Não foi possível carregar a solicitação.';
          });
      },
      ehEscolhida(sp) {
        return !!(this.escolhida && this.escolhida.idSolicitacao === sp.idSolicitacao);
      },
      saldoDe(sp) {
        return arredondar((+sp.valor || 0) - (+sp.valorDevolvido || 0));
      },
      projetoDe(sp) {
        if (!sp.nomeProjeto) return '';
        return sp.qtdeRateios > 1 ? sp.nomeProjeto + ' (+' + (sp.qtdeRateios - 1) + ' linhas)' : sp.nomeProjeto;
      },
      itemDe(r) {
        return r.idProjetoItemControle > 0 ? (r.nomeItem || 'Item ' + r.idProjetoItemControle) : '';
      },
      semConta(linhas) {
        return (linhas || []).filter(l => l.contaNoProjeto === false);
      },
      textoSemConta(linhas, nomeConta) {
        const projetos = this.semConta(linhas).map(l => l.nomeProjeto).filter((n, i, a) => a.indexOf(n) === i);
        const conta = nomeConta || (this.value && this.value.nomeContaExtrato) || 'desta conta';
        return (projetos.length === 1 ? 'O projeto ' + projetos[0] + ' não tem' : 'Os projetos ' + projetos.join(', ') + ' não têm')
          + ' a conta ' + conta + ' cadastrada. Cadastre a conta no projeto antes de gravar.';
      },
      podeConfirmar() {
        return !!(this.detalhe && this.detalhe.rateios.some(r => (+r.saldo || 0) > 0));
      },
      totalmenteDevolvida(sp) {
        return (+sp.valorDevolvido || 0) > 0 && this.saldoDe(sp) < 0.005;
      },
      confirmar() {
        if (!this.podeConfirmar()) return;

        const linhas = this.detalhe.rateios.map(r => Object.assign({}, r, {
          valorPago: +r.valor || 0, quantidadeOriginal: +r.quantidade || 0,
          valor: 0, valorTexto: '', quantidade: 0, quantidadeTexto: '0', quantidadeManual: false,
        }));

        const comSaldo = linhas.filter(l => (+l.saldo || 0) > 0);
        if (comSaldo.length === 1) {
          const linha = comSaldo[0];
          linha.valor = arredondar(Math.min(this.total, linha.saldo));
          linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
          this.ajustarQuantidade(linha);
        }

        this.$emit('input', Object.assign({}, this.detalhe, { linhas }));
        this.fechar();
      },
      remover() {
        this.$emit('input', null);
      },
      digitarValor(linha, evento) {
        linha.valorTexto = evento.target.value;
        linha.valor = arredondar(lerNumero(linha.valorTexto));
        this.ajustarQuantidade(linha);
        this.emitir();
      },
      sairValor(linha) {
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
      },
      digitarQuantidade(linha, evento) {
        linha.quantidadeTexto = evento.target.value;
        linha.quantidade = Math.max(0, lerNumero(linha.quantidadeTexto));
        linha.quantidadeManual = true;
        this.emitir();
      },
      unitarioDe(linha) {
        const quantidade = +linha.quantidadeOriginal || 0;
        return quantidade > 0 ? (+linha.valorPago || 0) / quantidade : 0;
      },
      porQuantidade(linha) {
        return linha.idProjetoItemControle > 0 && !(+linha.itemControleValorTotal) && (+linha.itemValorUnitario || 0) > 0;
      },
      unitarioBase(linha) {
        return this.porQuantidade(linha) ? (+linha.itemValorUnitario || 0) : this.unitarioDe(linha);
      },
      proporcional(linha) {
        const unitario = this.unitarioBase(linha);
        if (!(unitario > 0)) return 0;
        return Math.round(((+linha.valor || 0) / unitario) * 100) / 100;
      },
      faltaQuantidade(linha) {
        return !!linha.exigeQuantidade && (+linha.valor || 0) > 0 && !((+linha.quantidade || 0) > 0);
      },
      sugestaoQuantidade(linha) {
        if (!linha.exigeQuantidade || !((+linha.valor || 0) > 0)) return 0;
        const paga = +linha.quantidadeOriginal || 0;
        if (paga > 0 && Math.abs((+linha.valor || 0) - (+linha.valorPago || 0)) < 0.005) return paga;
        const sugerida = this.proporcional(linha);
        return paga > 0 ? Math.min(sugerida, paga) : sugerida;
      },
      ajustarQuantidade(linha) {
        if (linha.quantidadeManual || !(linha.idProjetoItemControle > 0)) return;
        linha.quantidade = this.sugestaoQuantidade(linha);
        linha.quantidadeTexto = linha.quantidade > 0 ? this.formatarQuantidade(linha.quantidade) : '';
      },
      tituloCi(linha) {
        if (this.faltaQuantidade(linha)) return 'Informe a quantidade devolvida do item ' + this.itemDe(linha);
        if (!(linha.idProjetoItemControle > 0)) return 'Detalhe da linha';
        return 'Controle de item: ' + this.itemDe(linha)
          + (linha.exigeQuantidade ? ' · qtd. devolvida ' + this.formatarQuantidade(linha.quantidade)
            + (linha.quantidadeManual ? '' : ' (sugerida pelo valor, confira)') : '');
      },
      abrirCi(linha) {
        this.ci = { linha, item: null, carregando: linha.idProjetoItemControle > 0, erro: '', invalida: '',
                    quantidadeTexto: (+linha.quantidade || 0) > 0 ? this.formatarQuantidade(linha.quantidade) : '' };
        if (!(linha.idProjetoItemControle > 0)) return;
        const ci = this.ci;
        conciliacaoProjetoServico.itemDevolucao(linha.idProjetoItemControle)
          .then(item => {
            ci.carregando = false;
            ci.item = item || null;
          })
          .catch(res => {
            ci.carregando = false;
            ci.erro = (res && res.body && res.body.message) || 'Não foi possível carregar o item.';
          });
        this.$nextTick(() => this.$refs.ciQuantidade && this.$refs.ciQuantidade.focus());
      },
      usoItem(item) {
        const limite = this.porQuantidade(this.ci.linha)
          ? (+item.quantidade || 0) * (+item.valorUnitario || 0)
          : (+item.valorUnitario || 0);
        if (!(limite > 0)) return null;
        return Math.max(0, ((+item.valorRealizado || 0) / limite) * 100);
      },
      quantidadeCi() {
        return Math.max(0, lerNumero(this.ci && this.ci.quantidadeTexto));
      },
      passoCi(delta) {
        const atual = this.quantidadeCi();
        const novo = Math.max(0, Math.round((atual + delta) * 10000) / 10000);
        this.ci.quantidadeTexto = novo > 0 ? this.formatarQuantidade(novo) : '';
        this.ci.invalida = '';
      },
      textoSugestao(linha) {
        const paga = +linha.quantidadeOriginal || 0;
        if (paga > 0 && Math.abs((+linha.valor || 0) - (+linha.valorPago || 0)) < 0.005) return 'devolução do total pago: ' + this.formatarQuantidade(paga) + ' un.';
        const conta = this.formatar(linha.valor) + ' ÷ ' + this.formatar(this.unitarioBase(linha)) + ' = ' + this.formatarQuantidade(this.proporcional(linha));
        return paga > 0 && this.proporcional(linha) > paga ? conta + ' (limitado a ' + this.formatarQuantidade(paga) + ' pagas)' : conta;
      },
      usarProporcional() {
        this.ci.quantidadeTexto = this.formatarQuantidade(this.sugestaoQuantidade(this.ci.linha));
      },
      confirmarCi() {
        const linha = this.ci.linha;
        const quantidade = Math.max(0, lerNumero(this.ci.quantidadeTexto));
        const paga = +linha.quantidadeOriginal || 0;
        if (!(quantidade > 0)) { this.ci.invalida = 'Informe a quantidade devolvida.'; return; }
        if (paga > 0 && quantidade > paga) {
          this.ci.invalida = 'A ' + this.siglaValor + ' pagou ' + this.formatarQuantidade(paga) + '; a devolução não pode passar disso.';
          return;
        }
        linha.quantidade = quantidade;
        linha.quantidadeTexto = this.formatarQuantidade(linha.quantidade);
        linha.quantidadeManual = true;
        this.ci = null;
        this.emitir();
      },
      usarSaldo(linha) {
        const restante = arredondar(this.falta + (+linha.valor || 0));
        linha.valor = arredondar(Math.max(0, Math.min(+linha.saldo || 0, restante)));
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
        this.ajustarQuantidade(linha);
        this.emitir();
      },
      emitir() {
        this.$emit('input', Object.assign({}, this.value, { linhas: this.linhas.slice() }));
      },
    },
  }
</script>

<template>
  <div class="dsv">
    <div v-if="!value" class="dsv-vazio">
      <button type="button" class="dsv-botao" @click="abrir">
        <i class="fa fa-undo"></i> É devolução de solicitação (SP, SB, SR, SD)
      </button>
      <small>Estorno de compra, diária ou bolsa paga a maior, reembolso devolvido... O valor volta para o projeto, rubrica e item de onde saiu.</small>
    </div>

    <div v-else class="dsv-card" :class="{ 'dsv-card-invalido': invalido }">
      <div class="dsv-cab-card">
        <div class="dsv-card-txt">
          <div class="dsv-l1">
            <b class="mono">{{ siglaValor }} {{ value.idSolicitacao }}</b>
            <span class="dsv-nome" :title="value.nomePessoa">{{ value.nomePessoa || '—' }}</span>
            <span class="dsv-valor mono">pago R$ {{ formatar(value.valor) }}</span>
          </div>
          <div class="dsv-l2">
            <span><i class="fa fa-calendar"></i> Pago em {{ value.dataPagamentoStr || '—' }}</span>
            <span v-if="value.valorDevolvido > 0" class="dsv-ja">Já devolvido R$ {{ formatar(value.valorDevolvido) }}</span>
            <span v-if="value.complemento" class="dsv-compl" :title="value.complemento">{{ value.complemento }}</span>
          </div>
        </div>
        <div class="dsv-card-acoes">
          <button type="button" class="dsv-mini" title="Trocar a solicitação" @click="abrir"><i class="fa fa-exchange"></i></button>
          <button type="button" class="dsv-mini dsv-mini-remover" title="Não é devolução" @click="remover"><i class="fa fa-times"></i></button>
        </div>
      </div>

      <table class="dsv-tab dsv-tab-linhas">
        <thead>
          <tr>
            <th>Projeto</th>
            <th>Rubrica</th>
            <th>Subrubrica</th>
            <th class="dsv-col-ci">CI <i class="fa fa-question-circle dsv-ajuda" title="Controle de item"></i></th>
            <th class="dsv-dir dsv-col-valor">Valor devolvido</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(l, i) in linhas" :key="'l' + i" :class="{ 'dsv-sem-saldo': !(l.saldo > 0) }">
            <td>
              <div class="dsv-campo-fixo" :class="{ 'dsv-campo-alerta': l.contaNoProjeto === false }">
                <i v-if="l.contaNoProjeto === false" class="fa fa-exclamation-triangle" title="A conta do extrato não está cadastrada neste projeto"></i>
                <input :id="'dsv-projeto-' + i" type="text" class="form-control" disabled :value="l.nomeProjeto" :title="l.nomeProjeto">
              </div>
            </td>
            <td><input :id="'dsv-rubrica-' + i" type="text" class="form-control" disabled :value="l.nomeRubrica" :title="l.nomeRubrica"></td>
            <td><input :id="'dsv-subrubrica-' + i" type="text" class="form-control" disabled :value="l.nomeSubrubrica" :title="l.nomeSubrubrica"></td>
            <td class="dsv-col-ci">
              <button type="button" class="dsv-ci" :class="{ 'dsv-ci-item': l.idProjetoItemControle > 0, 'dsv-ci-falta': faltaQuantidade(l) }"
                      :title="tituloCi(l)" @click="abrirCi(l)">
                <i class="fa" :class="l.idProjetoItemControle > 0 ? 'fa-cube' : 'fa-search-plus'"></i>
                <span v-if="l.exigeQuantidade && l.quantidade > 0" class="dsv-ci-badge mono" :class="{ 'dsv-ci-badge-sug': !l.quantidadeManual }">{{ formatarQuantidade(l.quantidade) }}</span>
              </button>
            </td>
            <td class="dsv-dir">
              <div class="dsv-valor-campo" :class="{ 'dsv-erro-campo': l.valor > l.saldo + 0.005 }">
                <input :id="'dsv-valor-' + i" type="text" class="form-control mono" :value="l.valorTexto" maxlength="20" placeholder="0,00"
                       :disabled="!(l.saldo > 0)" @input="digitarValor(l, $event)" @blur="sairValor(l)">
                <button v-if="l.saldo > 0 && Math.abs(falta) >= 0.005" type="button" class="dsv-usar" title="Usar o que falta, até o saldo da linha"
                        @click="usarSaldo(l)"><i class="fa fa-level-down"></i></button>
              </div>
              <small class="dsv-sub mono">saldo {{ formatar(l.saldo) }}</small>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="dsv-rodape-card">
        <div v-if="semConta(linhas).length" class="dsv-aviso-conta">
          <i class="fa fa-exclamation-triangle"></i> {{ textoSemConta(linhas) }}
        </div>
        <span v-if="linhasSemQuantidade.length" class="dsv-cont dsv-falta">
          <i class="fa fa-cube"></i> Item controlado por quantidade: informe no CI quantas unidades estão sendo devolvidas.
        </span>
        <span v-else-if="linhasAcimaDoSaldo.length" class="dsv-cont dsv-falta">
          <i class="fa fa-ban"></i> Valor acima do saldo da linha — a devolução não pode passar do que ainda não foi devolvido.
        </span>
        <span v-else-if="Math.abs(falta) < 0.005" class="dsv-cont dsv-bate">R$ {{ formatar(distribuido) }} · bate com o crédito</span>
        <span v-else-if="falta > 0" class="dsv-cont dsv-ok">R$ {{ formatar(distribuido) }} distribuídos · faltam R$ {{ formatar(falta) }}</span>
        <span v-else class="dsv-cont dsv-falta">R$ {{ formatar(distribuido) }} distribuídos · passou R$ {{ formatar(-falta) }}</span>
      </div>
    </div>

    <div v-if="ci" class="dsv-back dsv-back-ci">
      <div class="dsv-modal ci-modal" role="dialog" aria-modal="true" aria-label="Controle de item do projeto">
        <div class="ci-head">
          <div class="ci-head-ic" :class="ci.linha.idProjetoItemControle > 0 ? (porQuantidade(ci.linha) ? 'ci-qtd' : 'ci-valor') : 'ci-neutro'">
            <i class="fa" :class="ci.linha.idProjetoItemControle > 0 ? 'fa-cube' : 'fa-search-plus'"></i>
          </div>
          <div class="ci-head-txt">
            <h4>{{ ci.linha.idProjetoItemControle > 0 ? 'Controle de item do projeto' : 'Detalhe da linha' }}</h4>
            <div class="ci-trilha">
              <span class="ci-sol mono">{{ siglaValor }} {{ value.idSolicitacao }}</span>
              <span :title="ci.linha.nomeProjeto">{{ ci.linha.nomeProjeto }}</span>
              <i class="fa fa-angle-right"></i>
              <span :title="ci.linha.nomeRubrica">{{ ci.linha.nomeRubrica }}</span>
              <i class="fa fa-angle-right"></i>
              <span :title="ci.linha.nomeSubrubrica">{{ ci.linha.nomeSubrubrica }}</span>
            </div>
          </div>
          <span v-if="ci.linha.idProjetoItemControle > 0" class="ci-modo" :class="porQuantidade(ci.linha) ? 'ci-qtd' : 'ci-valor'">
            <i class="fa" :class="porQuantidade(ci.linha) ? 'fa-sort-numeric-asc' : 'fa-money'"></i>
            {{ porQuantidade(ci.linha) ? 'Por quantidade' : 'Por valor total' }}
          </span>
        </div>

        <div class="ci-corpo">
          <section class="ci-card">
            <div class="ci-card-tit"><span class="ci-rotulo">Rateio da solicitação</span></div>
            <div class="ci-grade ci-grade-3">
              <div class="ci-campo">
                <label>Projeto</label>
                <input type="text" class="form-control" readonly tabindex="-1" :value="ci.linha.nomeProjeto" :title="ci.linha.nomeProjeto">
              </div>
              <div class="ci-campo">
                <label>Rubrica</label>
                <input type="text" class="form-control" readonly tabindex="-1" :value="ci.linha.nomeRubrica" :title="ci.linha.nomeRubrica">
              </div>
              <div class="ci-campo">
                <label>Subrubrica</label>
                <input type="text" class="form-control" readonly tabindex="-1" :value="ci.linha.nomeSubrubrica" :title="ci.linha.nomeSubrubrica">
              </div>
            </div>
            <div class="ci-grade ci-grade-4">
              <div class="ci-campo">
                <label>Pago na {{ siglaValor }}</label>
                <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatar(ci.linha.valorPago)">
              </div>
              <div class="ci-campo">
                <label>Já devolvido</label>
                <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatar(ci.linha.valorDevolvido)">
              </div>
              <div class="ci-campo">
                <label>Saldo para devolver</label>
                <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatar(ci.linha.saldo)">
              </div>
              <div class="ci-campo">
                <label>Esta devolução</label>
                <input type="text" class="form-control mono ci-num ci-destaque" readonly tabindex="-1" :value="formatar(ci.linha.valor)">
              </div>
            </div>
            <div v-if="ci.linha.idProjetoItemControle > 0" class="ci-grade ci-grade-4">
              <div class="ci-campo">
                <label>Quant. paga na {{ siglaValor }}</label>
                <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatarQuantidade(ci.linha.quantidadeOriginal)">
              </div>
              <div class="ci-campo">
                <label>Valor por unidade na {{ siglaValor }}</label>
                <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="unitarioDe(ci.linha) > 0 ? formatar(unitarioDe(ci.linha)) : '—'">
              </div>
            </div>
          </section>

          <section v-if="ci.linha.idProjetoItemControle > 0" class="ci-card">
            <div class="ci-card-tit"><span class="ci-rotulo">Item de controle no projeto</span></div>
            <div class="ci-grade ci-grade-1">
              <div class="ci-campo">
                <label>Item</label>
                <input type="text" class="form-control" readonly tabindex="-1"
                       :value="ci.item ? ci.item.nome : itemDe(ci.linha)" :title="ci.item ? ci.item.nome : itemDe(ci.linha)">
              </div>
            </div>
            <div v-if="ci.carregando" class="ci-msg"><i class="fa fa-spinner fa-pulse"></i> Carregando o item...</div>
            <div v-else-if="ci.erro" class="ci-msg ci-msg-erro"><i class="fa fa-exclamation-triangle"></i> {{ ci.erro }}</div>
            <template v-else-if="ci.item">
              <div class="ci-grade ci-grade-5">
                <div class="ci-campo">
                  <label>Quant. prevista</label>
                  <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatarQuantidade(ci.item.quantidade)">
                </div>
                <div class="ci-campo">
                  <label>Quant. realizada</label>
                  <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatarQuantidade(ci.item.quantidadeRealizado)">
                </div>
                <div class="ci-campo">
                  <label>{{ porQuantidade(ci.linha) ? 'Valor unitário' : 'Limite do item' }}</label>
                  <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatar(ci.item.valorUnitario)">
                </div>
                <div class="ci-campo">
                  <label>Valor realizado</label>
                  <input type="text" class="form-control mono ci-num" readonly tabindex="-1" :value="formatar(ci.item.valorRealizado)">
                </div>
                <div class="ci-campo">
                  <label>Saldo</label>
                  <input type="text" class="form-control mono ci-num" :class="ci.item.saldo < 0 ? 'ci-neg' : 'ci-pos'" readonly tabindex="-1" :value="formatar(ci.item.saldo)">
                </div>
              </div>
              <div v-if="usoItem(ci.item) !== null" class="ci-uso">
                <div class="ci-uso-barra"><div :style="{ width: Math.min(100, usoItem(ci.item)) + '%' }" :class="{ 'ci-uso-alto': usoItem(ci.item) > 90 }"></div></div>
                <small>{{ usoItem(ci.item).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) }}% usado</small>
              </div>
            </template>
            <p class="ci-explica">
              <template v-if="porQuantidade(ci.linha)">
                Cada unidade vale <b class="mono">R$ {{ formatar(ci.linha.itemValorUnitario) }}</b>. O saldo do item anda pela quantidade, por isso a devolução precisa dizer quantas unidades voltam.
              </template>
              <template v-else>
                O saldo do item anda pelo valor até o limite.
                <template v-if="ci.linha.exigeQuantidade">O item também limita a quantidade ({{ formatarQuantidade(ci.linha.itemQuantidadePrevista) }} previstas), então informe quantas unidades voltam.</template>
                <template v-else>Não precisa informar quantidade.</template>
              </template>
            </p>
          </section>

          <section v-if="ci.linha.exigeQuantidade" class="ci-card ci-card-qtd" :class="{ 'ci-card-erro': !!ci.invalida }">
            <div class="ci-qtd-linha">
              <div class="ci-qtd-campo">
                <label for="dsv-ci-quantidade">Quantidade devolvida <span class="dsv-obr">*</span></label>
                <div class="ci-stepper">
                  <button type="button" title="Menos uma" @click="passoCi(-1)"><i class="fa fa-minus"></i></button>
                  <input id="dsv-ci-quantidade" ref="ciQuantidade" type="text" class="mono" v-model="ci.quantidadeTexto" maxlength="12"
                         placeholder="0" @input="ci.invalida = ''" @keydown.enter.prevent="confirmarCi">
                  <button type="button" title="Mais uma" @click="passoCi(1)"><i class="fa fa-plus"></i></button>
                </div>
              </div>
              <div v-if="sugestaoQuantidade(ci.linha) > 0" class="ci-sugestao-info">
                <span><i class="fa fa-magic"></i> Sugestão: <b class="mono">{{ formatarQuantidade(sugestaoQuantidade(ci.linha)) }}</b></span>
                <small class="mono">{{ textoSugestao(ci.linha) }}</small>
                <button v-if="quantidadeCi() !== sugestaoQuantidade(ci.linha)" type="button" class="ci-sugestao-voltar" @click="usarProporcional">
                  <i class="fa fa-undo"></i> Voltar à sugestão
                </button>
              </div>
            </div>
            <div v-if="ci.item && quantidadeCi() > 0" class="ci-previa">
              <i class="fa fa-long-arrow-right"></i>
              Realizado do item passa de <b class="mono">{{ formatarQuantidade(ci.item.quantidadeRealizado) }}</b>
              para <b class="mono">{{ formatarQuantidade(ci.item.quantidadeRealizado - quantidadeCi()) }}</b>
            </div>
            <small v-if="ci.invalida" class="ci-erro"><i class="fa fa-exclamation-circle"></i> {{ ci.invalida }}</small>
            <small v-else-if="!ci.linha.quantidadeManual && quantidadeCi() === sugestaoQuantidade(ci.linha)" class="ci-dica ci-dica-sug">
              <i class="fa fa-info-circle"></i> Preenchido com a sugestão pelo valor. Confira com o que foi devolvido e confirme em Ok.
            </small>
            <small v-else class="ci-dica">Quantas unidades voltam para o saldo do item.</small>
          </section>
        </div>

        <div class="dsv-rodape">
          <span class="dsv-cont"></span>
          <button v-if="ci.linha.exigeQuantidade" type="button" class="btn btn-primary" @click="confirmarCi"><i class="fa fa-check"></i> Ok</button>
          <button type="button" class="dsv-sair" @click="ci = null"><i class="fa fa-sign-out"></i> {{ ci.linha.exigeQuantidade ? 'Cancelar' : 'Sair' }}</button>
        </div>
      </div>
    </div>

    <div v-if="aberto" class="dsv-back">
      <div class="dsv-modal">
        <div class="dsv-cab">
          <h4><i class="fa fa-undo"></i> Devolução de solicitação</h4>
          <small>Escolha a solicitação que gerou o pagamento devolvido. Aparecem só as que têm lançamento pago.</small>
        </div>

        <div class="dsv-filtros" @keydown.enter="enterNoFiltro">
          <div class="dsv-filtro dsv-filtro-tipo">
            <label>Tipo <span class="dsv-obr">*</span></label>
            <div class="dsv-tipos" :class="{ 'dsv-tipos-pendente': !filtro.tipo }" role="tablist">
              <button v-for="t in tipos" :key="t.sigla" type="button" class="dsv-tipo" :class="{ ativo: filtro.tipo === t.sigla }"
                      role="tab" :aria-selected="filtro.tipo === t.sigla" @click="escolherTipo(t.sigla)">
                <b class="mono">{{ t.sigla }}</b> {{ t.nome }}
              </button>
            </div>
          </div>
          <div class="dsv-filtro dsv-filtro-lg">
            <label>Número {{ rotuloTipo }}, favorecido ou CPF/CNPJ</label>
            <div class="dsv-busca-linha">
              <input ref="busca" type="text" class="form-control" v-model="filtro.busca" maxlength="100" placeholder="Ex.: 245670 ou nome do favorecido">
              <button type="button" class="btn btn-success no-margins" :disabled="carregando || !filtro.tipo" @click="buscarAgora" title="Buscar agora (Enter)">
                <i class="fa" :class="carregando ? 'fa-spinner fa-pulse' : 'fa-search'"></i> Buscar
              </button>
            </div>
          </div>
          <div class="dsv-filtro dsv-filtro-sm">
            <label>Pago de</label>
            <date-picker v-model="filtro.dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="dsv-filtro dsv-filtro-sm">
            <label>até</label>
            <date-picker v-model="filtro.dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="dsv-chips">
            <small v-if="filtro.tipo === 'SB'" class="dsv-tipo-dica">Só bolsa. RPA e adicional variável ficam de fora porque têm impostos.</small>
            <button v-for="s in sugestoesBusca" :key="'sug-' + s" type="button" class="dsv-chip" :class="{ ativo: sugestaoAtiva(s) }" @click="alternarSugestao(s)">
              <i v-if="sugestaoAtiva(s)" class="fa fa-check"></i> Do extrato: {{ s }}
            </button>
            <button v-if="filtro.busca || filtro.dataIni || filtro.dataFim" type="button" class="dsv-chip dsv-chip-limpar" @click="limparFiltros">
              <i class="fa fa-eraser"></i> Limpar filtros
            </button>
            <small class="dsv-dica-filtro">Sem datas, a busca olha os pagamentos dos últimos 12 meses; as de valor maior ou igual ao crédito vêm primeiro.</small>
          </div>
        </div>

        <div class="dsv-corpo">
          <div class="dsv-lista">
            <div v-if="!filtro.tipo" class="dsv-info"><i class="fa fa-hand-o-up"></i> Escolha o tipo da solicitação: pagamento, bolsa, reembolso ou diárias.</div>
            <div v-else-if="!podeBuscar && !carregando" class="dsv-info"><i class="fa fa-search"></i> Digite o número da {{ filtro.tipo }}, o favorecido (3 letras ou mais) ou o CPF/CNPJ, ou escolha as datas do pagamento.</div>
            <div v-else-if="carregando && !lista" class="dsv-info"><i class="fa fa-spinner fa-pulse"></i> Buscando as solicitações...</div>
            <div v-else-if="erro" class="dsv-info dsv-erro">{{ erro }}</div>
            <div v-else-if="lista && !lista.length" class="dsv-info">Nenhuma solicitação paga com esses filtros.</div>
            <template v-else-if="lista">
              <div v-if="noLimite" class="dsv-limite"><i class="fa fa-info-circle"></i> Mostrando {{ lista.length }}. Digite o número da {{ filtro.tipo }} para ir direto.</div>
              <table class="dsv-tab" :class="{ 'dsv-tab-carregando': carregando }">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ filtro.tipo }}</th>
                    <th>Pago em</th>
                    <th>Favorecido / Projeto</th>
                    <th>Complemento</th>
                    <th class="dsv-dir">Pago</th>
                    <th class="dsv-dir">Devolvido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sp in lista" :key="sp.idSolicitacao" :class="{ on: ehEscolhida(sp), 'dsv-devolvida': totalmenteDevolvida(sp) }" @click="escolher(sp)">
                    <td><input type="radio" :checked="ehEscolhida(sp)" @click.stop="escolher(sp)"></td>
                    <td class="mono dsv-nowrap">{{ sp.idSolicitacao }}</td>
                    <td class="mono dsv-nowrap">{{ sp.dataPagamentoStr }}</td>
                    <td class="dsv-cel-nome">
                      <div :title="sp.nomePessoa">{{ sp.nomePessoa || '—' }}</div>
                      <small v-if="sp.nomeProjeto" :title="sp.nomeProjeto">{{ projetoDe(sp) }}</small>
                    </td>
                    <td class="dsv-cel-compl"><div :title="sp.complemento">{{ sp.complemento || '—' }}</div></td>
                    <td class="mono dsv-dir">{{ formatar(sp.valor) }}</td>
                    <td class="mono dsv-dir">
                      {{ sp.valorDevolvido > 0 ? formatar(sp.valorDevolvido) : '—' }}
                      <small v-if="totalmenteDevolvida(sp)" class="dsv-sub dsv-tag-total">tudo devolvido</small>
                      <small v-else-if="sp.valorDevolvido > 0" class="dsv-sub">saldo {{ formatar(saldoDe(sp)) }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>

          <div class="dsv-detalhe">
            <div v-if="!escolhida" class="dsv-info">Clique numa solicitação para ver o rateio.</div>
            <div v-else-if="carregandoDetalhe" class="dsv-info"><i class="fa fa-spinner fa-pulse"></i> Carregando a solicitação...</div>
            <div v-else-if="erroDetalhe" class="dsv-info dsv-erro">{{ erroDetalhe }}</div>
            <template v-else-if="detalhe">
              <div class="dsv-det-cab">
                <b class="mono">{{ detalhe.tipoSolicitacao }} {{ detalhe.idSolicitacao }}</b>
                <span class="mono">R$ {{ formatar(detalhe.valor) }}</span>
              </div>
              <dl class="dsv-dl">
                <dt>Favorecido</dt>
                <dd>{{ detalhe.nomePessoa || '—' }}<small v-if="detalhe.cpfcnpj" class="mono"> · {{ detalhe.cpfcnpj }}</small></dd>
                <dt>Pago em</dt>
                <dd class="mono">{{ detalhe.dataPagamentoStr || '—' }} · lançamento {{ detalhe.idLancamento }}</dd>
                <template v-if="detalhe.complemento"><dt>Complemento</dt><dd>{{ detalhe.complemento }}</dd></template>
              </dl>
              <div class="dsv-secao">
                <h5>Devoluções já feitas</h5>
                <div v-if="!detalhe.devolucoes || !detalhe.devolucoes.length" class="dsv-nenhuma">Nenhuma devolução vinculada a esta {{ detalhe.tipoSolicitacao }}.</div>
                <template v-else>
                  <div v-for="d in detalhe.devolucoes" :key="'d' + d.idLancamento" class="dsv-rat">
                    <div class="dsv-linha">
                      <span class="mono">{{ d.dataStr || d.dataCadastroStr }} · lanç. {{ d.idLancamento }}</span>
                      <span class="mono">{{ formatar(d.valor) }}</span>
                    </div>
                    <div class="dsv-rat-l2">
                      <span class="dsv-linha-txt" :title="d.nomeConta + (d.documento ? ' · ' + d.documento : '')">
                        {{ d.nomeConta }}<template v-if="d.documento"> · {{ d.documento }}</template>
                      </span>
                    </div>
                  </div>
                  <div class="dsv-saldo-sp" :class="{ 'dsv-saldo-zero': saldoDe(detalhe) < 0.005 }">
                    <span>Pago {{ formatar(detalhe.valor) }} − devolvido {{ formatar(detalhe.valorDevolvido) }}</span>
                    <b class="mono">saldo {{ formatar(saldoDe(detalhe)) }}</b>
                  </div>
                  <div v-if="saldoDe(detalhe) < 0.005" class="dsv-aviso-conta">
                    <i class="fa fa-ban"></i> Esta {{ detalhe.tipoSolicitacao }} já foi devolvida por inteiro. Não dá para vincular outra devolução.
                  </div>
                  <div v-else-if="total > saldoDe(detalhe) + 0.005" class="dsv-aviso-saldo">
                    <i class="fa fa-exclamation-triangle"></i> O crédito (R$ {{ formatar(total) }}) passa do saldo da {{ detalhe.tipoSolicitacao }}. Só R$ {{ formatar(saldoDe(detalhe)) }} podem ir para ela; o resto precisa de outro lançamento.
                  </div>
                </template>
              </div>
              <div class="dsv-secao">
                <h5>Rateio do pagamento</h5>
                <div v-if="semConta(detalhe.rateios).length" class="dsv-aviso-conta">
                  <i class="fa fa-exclamation-triangle"></i>
                  {{ textoSemConta(detalhe.rateios, detalhe.nomeContaExtrato) }}
                </div>
                <div v-for="(r, i) in detalhe.rateios" :key="'r' + i" class="dsv-rat">
                  <div class="dsv-linha">
                    <span class="dsv-linha-txt" :title="r.nomeProjeto">{{ r.nomeProjeto }}</span>
                    <span class="mono">{{ formatar(r.valor) }}</span>
                  </div>
                  <div class="dsv-rat-l2">
                    <span class="dsv-linha-txt" :title="r.nomeSubrubrica">{{ r.nomeSubrubrica }}</span>
                    <span v-if="r.valorDevolvido > 0" class="mono dsv-ja">devolvido {{ formatar(r.valorDevolvido) }}</span>
                  </div>
                  <div v-if="r.idProjetoItemControle > 0" class="dsv-rat-l2">
                    <span class="dsv-linha-txt" :title="itemDe(r)"><i class="fa fa-cube"></i> {{ itemDe(r) }}</span>
                    <span class="mono">qtd. {{ formatarQuantidade(r.quantidade) }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="dsv-rodape">
          <span v-if="escolhida" class="dsv-cont dsv-ok">{{ escolhida.tipoSolicitacao }} {{ escolhida.idSolicitacao }} · R$ {{ formatar(escolhida.valor) }}</span>
          <span v-else class="dsv-cont">Nenhuma solicitação escolhida</span>
          <button type="button" class="btn btn-primary" :disabled="!podeConfirmar() || carregandoDetalhe" @click="confirmar">
            <i class="fa fa-link"></i> Usar esta solicitação
          </button>
          <button type="button" class="dsv-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .dsv { margin: 0; }
  .dsv-vazio { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; }
  .dsv-vazio small { color: #8a939c; font-size: 11.5px; }
  .dsv-botao { height: 28px; padding: 0 11px; background: #fff; border: 1px solid #2b6cb0; border-radius: 5px; font-size: 12px; font-weight: 600; color: #2b6cb0; }
  .dsv-botao:hover { background: #eef4fb; }
  .dsv-tipos { display: flex; align-items: center; border-radius: 5px; }
  .dsv-tipos-pendente { box-shadow: 0 0 0 3px rgba(43,108,176,.18); }
  .dsv-tipo { height: 32px; white-space: nowrap; padding: 0 14px; background: #fff; border: 1px solid #d3d8de; margin-left: -1px; font-size: 12.5px; color: #3b444d; }
  .dsv-tipo:first-child { border-radius: 5px 0 0 5px; margin-left: 0; }
  .dsv-tipo:nth-child(4) { border-radius: 0 5px 5px 0; }
  .dsv-tipo b { color: #8a939c; margin-right: 3px; }
  .dsv-tipo:hover { background: #f5f8fb; }
  .dsv-tipo.ativo { background: #eef4fb; border-color: #2b6cb0; color: #1f4f82; font-weight: 600; position: relative; z-index: 1; }
  .dsv-tipo.ativo b { color: #2b6cb0; }
  .dsv-tipo-dica { color: #8a6d1e; font-size: 11.5px; }
  .dsv-card { border: 1px solid #d6e3f2; background: #f5f9fd; border-radius: 6px; padding: 8px 10px; }
  .dsv-card-invalido { border-color: #e5b5b5; }
  .dsv-cab-card { display: flex; gap: 10px; align-items: flex-start; }
  .dsv-card-txt { flex: 1 1 auto; min-width: 0; }
  .dsv-l1 { display: flex; gap: 10px; align-items: baseline; font-size: 13px; color: #1c2024; min-width: 0; }
  .dsv-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-valor { flex: none; font-weight: 600; }
  .dsv-l2 { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11.5px; color: #6b747e; margin-top: 2px; min-width: 0; }
  .dsv-l2 .fa { color: #9aa3ac; }
  .dsv-compl { max-width: 360px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-ja { color: #8a5a00; }
  .dsv-aviso-conta { flex-basis: 100%; margin: 0 0 8px; padding: 7px 10px; border-radius: 5px; background: #fdecea; color: #a5281b; font-size: 12px; font-weight: 600; line-height: 1.4; }
  .dsv-sem-conta { color: #c0392b; margin-right: 3px; }
  .dsv-card-acoes { flex: none; display: flex; gap: 4px; }
  .dsv-mini { width: 26px; height: 26px; border: 1px solid #d3d8de; border-radius: 4px; background: #fff; color: #5b6570; }
  .dsv-mini:hover { background: #eef4fb; border-color: #2b6cb0; color: #2b6cb0; }
  .dsv-mini-remover:hover { background: #fbeaea; border-color: #e5b5b5; color: #a13c3c; }
  .dsv-tab-linhas { margin-top: 8px; background: #fff; border: 1px solid #e6eaee; border-radius: 5px; table-layout: fixed; }
  .dsv-tab-linhas td { vertical-align: middle; }
  .dsv-tab-linhas td.mono { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .dsv-cel-txt { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-col-ci { width: 52px; text-align: center; white-space: nowrap; }
  .dsv-ajuda { color: #a5aab0; cursor: help; font-size: 12px; margin-left: 2px; }
  .dsv-ajuda:hover { color: #1c84c6; }
  .dsv-tab-linhas td { padding: 7px 6px; }
  .dsv-tab-linhas td > .form-control,
  .dsv-campo-fixo .form-control { height: 34px; font-size: 13px; border: 1px solid #d2d6db; border-radius: 2px; box-shadow: none; }
  .dsv-tab-linhas .form-control[disabled] { background: #eee; color: #676a6c; cursor: default; text-overflow: ellipsis; }
  .dsv-campo-fixo { position: relative; }
  .dsv-campo-fixo .fa { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: #ED5565; font-size: 12px; z-index: 1; }
  .dsv-campo-alerta .form-control { padding-left: 27px; border-color: #ED5565; }
  .dsv-col-valor { width: 170px; }
  .dsv-ci { width: 34px; height: 34px; border: 1px solid #d2d6db; border-radius: 2px; background: #fff; color: #8a939c; }
  .dsv-ci:hover { background: #f5f8fb; border-color: #8a939c; }
  .dsv-ci-item { color: #1e7d4f; border-color: #a9d4b6; background: #f1f9f4; }
  .dsv-ci-item:hover { background: #e5f2ea; border-color: #1e7d4f; }
  .dsv-ci { position: relative; }
  .dsv-ci-falta { color: #b23b3b; border-color: #e5b5b5; background: #fdf3f3; }
  .dsv-ci-falta:hover { background: #fbe6e6; border-color: #b23b3b; }
  .dsv-ci-badge-sug { background: #d08a2c !important; }
  .dsv-ci-badge { position: absolute; top: -7px; right: -9px; min-width: 16px; height: 16px; padding: 0 4px; border-radius: 8px;
                  background: #1e7d4f; color: #fff; font-size: 10px; line-height: 16px; text-align: center; }
  .dsv-obr { color: #ED5565; }
  .dsv-back-ci { z-index: 3500; }
  .ci-modal { max-width: 860px; overflow: hidden; }
  .ci-head { display: flex; align-items: center; gap: 14px; padding: 16px 22px; border-bottom: 1px solid #eef1f4;
             background: linear-gradient(180deg, #fbfcfd 0%, #fff 100%); }
  .ci-head-ic { flex: none; width: 42px; height: 42px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .ci-head-ic.ci-qtd { background: #e7f4ec; color: #1e7d4f; }
  .ci-head-ic.ci-valor { background: #e8f0fa; color: #2b6cb0; }
  .ci-head-ic.ci-neutro { background: #f1f3f5; color: #6b7682; }
  .ci-head-txt { flex: 1 1 auto; min-width: 0; }
  .ci-head-txt h4 { margin: 0 0 4px; font-size: 16px; font-weight: 600; color: #1c2024; }
  .ci-trilha { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #6b7682; min-width: 0; white-space: nowrap; overflow: hidden; }
  .ci-trilha > span:not(.ci-sol) { overflow: hidden; text-overflow: ellipsis; min-width: 0; }
  .ci-trilha .fa { color: #b8c0c8; }
  .ci-sol { flex: none; background: #1c2024; color: #fff; border-radius: 4px; padding: 1px 7px; font-size: 11px; font-weight: 600; }
  .ci-modo { flex: none; display: inline-flex; align-items: center; gap: 6px; border-radius: 999px; padding: 5px 12px; font-size: 12px; font-weight: 600; }
  .ci-modo.ci-qtd { background: #e7f4ec; color: #1d6a43; border: 1px solid #b9dfc8; }
  .ci-modo.ci-valor { background: #e8f0fa; color: #1f4f82; border: 1px solid #c4d7ee; }
  .ci-corpo { padding: 16px 22px; overflow: auto; display: flex; flex-direction: column; gap: 12px; background: #f7f9fb; }
  .ci-card { background: #fff; border: 1px solid #e6eaee; border-radius: 10px; padding: 14px 16px; }
  .ci-card-tit { display: flex; flex-direction: column; gap: 2px; margin-bottom: 10px; }
  .ci-rotulo { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .06em; color: #8a939c; }
  .ci-grade { display: grid; gap: 10px; }
  .ci-grade + .ci-grade { margin-top: 10px; }
  .ci-grade-1 { grid-template-columns: minmax(0, 1fr); }
  .ci-grade-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .ci-grade-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .ci-grade-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .ci-campo { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
  .ci-campo label { margin: 0; font-size: 13px; font-weight: 700; color: #676a6c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .ci-campo .form-control[readonly] { height: 34px; font-size: 13px; background: #eee; border: 1px solid #d2d6db; border-radius: 2px; color: #676a6c; cursor: default; box-shadow: none; }
  .ci-campo .form-control[readonly]:focus { border-color: #d2d6db; }
  .ci-num { text-align: right; }
  .ci-campo .form-control.ci-destaque { color: #1c84c6; font-weight: 700; }
  .ci-campo .form-control.ci-pos { color: #1ab394; font-weight: 700; }
  .ci-campo .form-control.ci-neg { color: #ED5565; font-weight: 700; }
  .ci-uso { display: flex; align-items: center; gap: 10px; margin-top: 10px; }
  .ci-uso-barra { flex: 1 1 auto; height: 6px; border-radius: 3px; background: #edf0f3; overflow: hidden; }
  .ci-uso-barra div { height: 100%; border-radius: 3px; background: #3c9a6b; }
  .ci-uso-barra div.ci-uso-alto { background: #d08a2c; }
  .ci-uso small { flex: none; font-size: 11px; color: #6b7682; }
  .ci-explica { margin: 10px 0 0; font-size: 12.5px; color: #4b5560; line-height: 1.55; }
  .ci-msg { font-size: 12.5px; color: #6b7682; padding: 6px 0; }
  .ci-msg-erro { color: #b23b3b; }
  .ci-card-qtd { border-color: #b9dfc8; box-shadow: 0 0 0 3px rgba(60,154,107,.08); }
  .ci-card-qtd.ci-card-erro { border-color: #e5b5b5; box-shadow: 0 0 0 3px rgba(178,59,59,.08); }
  .ci-qtd-linha { display: flex; align-items: flex-end; gap: 14px; flex-wrap: wrap; }
  .ci-qtd-campo { flex: none; display: flex; flex-direction: column; gap: 6px; }
  .ci-qtd-campo label { margin: 0; font-size: 13px; font-weight: 700; color: #676a6c; }
  .ci-stepper { display: inline-flex; align-items: stretch; border: 1px solid #d2d6db; border-radius: 2px; overflow: hidden; background: #fff; height: 42px; }
  .ci-card-erro .ci-stepper { border-color: #ED5565; }
  .ci-card-erro .ci-qtd-campo label { color: #ED5565; }
  .ci-stepper button { flex: none; width: 40px; border: 0; background: #f4f6f8; color: #4b5560; }
  .ci-stepper button:hover { background: #e9edf1; color: #1c2024; }
  .ci-stepper input { flex: none; width: 110px; min-width: 0; border: 0; border-left: 1px solid #e3e8ed; border-right: 1px solid #e3e8ed; text-align: center; font-size: 18px; font-weight: 600; color: #1c2024; outline: none; }
  .ci-stepper input:focus { background: #fbfdff; }
  .ci-sugestao-info { display: flex; flex-direction: column; justify-content: center; gap: 2px; min-height: 42px; padding: 4px 12px;
                      border-left: 3px solid #9cc7ae; background: #f3faf6; color: #1d6a43; font-size: 13px; }
  .ci-sugestao-info b { font-size: 14px; }
  .ci-sugestao-info small { font-size: 11.5px; color: #6b8a78; }
  .ci-sugestao-voltar { align-self: flex-start; border: 0; background: none; padding: 0; font-size: 12px; color: #1c84c6; }
  .ci-sugestao-voltar:hover { text-decoration: underline; }
  .ci-dica-sug { color: #8a6d1e; }
  .ci-previa { margin-top: 10px; font-size: 12.5px; color: #1d6a43; background: #f3faf6; border-radius: 6px; padding: 7px 10px; }
  .ci-dica { display: block; margin-top: 8px; font-size: 11.5px; color: #8a939c; }
  .ci-erro { display: block; margin-top: 8px; font-size: 12.5px; color: #ED5565; }
  @media (max-width: 720px) {
    .ci-grade-3, .ci-grade-4, .ci-grade-5 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .ci-head { flex-wrap: wrap; }
  }
  .dsv-col-qtd { width: 96px; }
  .dsv-valor-campo { display: flex; gap: 4px; justify-content: flex-end; min-width: 0; }
  .dsv-valor-campo .form-control { height: 34px; font-size: 13px; text-align: right; flex: 1 1 auto; width: auto; min-width: 0; border: 1px solid #d2d6db; border-radius: 2px; box-shadow: none; }
  .dsv-valor-campo .form-control[disabled] { background: #eee; }
  .dsv-erro-campo .form-control { border-color: #d9534f; background: #fdf3f3; }
  .dsv-qtd { height: 28px; font-size: 12.5px; text-align: right; width: 100%; display: inline-block; }
  .dsv-usar { flex: none; width: 34px; height: 34px; border: 1px solid #d2d6db; border-radius: 2px; background: #fff; color: #2b6cb0; }
  .dsv-usar:hover { background: #eef4fb; border-color: #2b6cb0; }
  .dsv-sem-saldo { opacity: .55; }
  .dsv-devolvida td { color: #9aa3ac; }
  .dsv-tag-total { color: #a13c3c; font-weight: 600; }
  .dsv-nenhuma { font-size: 12px; color: #8a939c; }
  .dsv-saldo-sp { display: flex; justify-content: space-between; gap: 10px; font-size: 12px; color: #4b545e; padding: 6px 8px; border-radius: 5px; background: #eef4fb; margin-bottom: 6px; }
  .dsv-saldo-zero { background: #fbeeee; color: #a13c3c; }
  .dsv-aviso-saldo { margin: 0 0 8px; padding: 7px 10px; border-radius: 5px; background: #fffaf0; border: 1px solid #f0dfb8; color: #8a5a00; font-size: 12px; font-weight: 600; line-height: 1.4; }
  .dsv-rodape-card { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; margin-top: 8px; }
  .dsv-dica { color: #8a939c; font-size: 11.5px; }

  .dsv-back { position: fixed; inset: 0; background: rgba(16,24,40,.5); z-index: 3400; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .dsv-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); width: 100%; max-width: 1180px; max-height: 92vh; display: flex; flex-direction: column; }
  .dsv-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; flex: 0 0 auto; }
  .dsv-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .dsv-cab small { color: #8a939c; font-size: 12.5px; }
  .dsv-filtros { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px; padding: 12px 20px; border-bottom: 1px solid #eef1f4; background: #fafbfc; flex: 0 0 auto; }
  .dsv-filtro { display: flex; flex-direction: column; flex: 1 1 130px; min-width: 0; }
  .dsv-filtro.dsv-filtro-tipo { flex: 0 0 auto; min-width: auto; }
  .dsv-filtro-lg { flex: 3 1 260px; }
  .dsv-filtro-sm { flex: 0 1 140px; }
  .dsv-filtro label { font-size: 13px; font-weight: 700; color: #676a6c; margin-bottom: 5px; }
  .dsv-filtro .form-control { height: 32px; font-size: 12.5px; }
  .dsv-busca-linha { display: flex; gap: 6px; }
  .dsv-busca-linha .form-control { flex: 1 1 auto; min-width: 0; }
  .dsv-busca-linha .btn { height: 32px; padding: 0 12px; font-size: 12.5px; flex: 0 0 auto; }
  .dsv-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; flex: 1 1 100%; }
  .dsv-chip { height: 28px; padding: 0 10px; border: 1px dashed #b9c3cd; border-radius: 14px; background: #fff; color: #2b6cb0; font-size: 12px; font-weight: 600; }
  .dsv-chip:hover { background: #f1f5f9; border-color: #2b6cb0; }
  .dsv-chip.ativo { border-style: solid; border-color: #0f8a5f; background: #e8f5ef; color: #0a6d4d; }
  .dsv-chip-limpar { color: #5b6570; }
  .dsv-dica-filtro { color: #8a939c; font-size: 11.5px; }
  .dsv-corpo { display: flex; flex: 1 1 auto; min-height: 280px; overflow: hidden; }
  .dsv-lista { flex: 1 1 auto; min-width: 0; overflow: auto; padding: 12px 16px 12px 20px; }
  .dsv-detalhe { flex: 0 0 330px; overflow: auto; padding: 12px 20px 12px 16px; border-left: 1px solid #eef1f4; background: #fbfcfd; }
  .dsv-info { padding: 28px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .dsv-erro { color: #a13c3c; }
  .dsv-limite { font-size: 12px; color: #8a5a00; background: #fffaf0; border: 1px solid #f0dfb8; border-radius: 5px; padding: 7px 10px; margin-bottom: 10px; }
  .dsv-tab { width: 100%; border-collapse: collapse; font-size: 12.5px; color: #3b444d; }
  .dsv-tab-carregando { opacity: .55; }
  .dsv-tab th { position: sticky; top: 0; background: #fff; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; text-align: left; padding: 6px 8px; border-bottom: 1px solid #e6e9ed; }
  .dsv-tab td { padding: 7px 8px; border-bottom: 1px solid #f0f2f4; vertical-align: top; }
  .dsv-lista .dsv-tab tbody tr { cursor: pointer; }
  .dsv-lista .dsv-tab tbody tr:hover { background: #f7f9fa; }
  .dsv-tab tbody tr.on { background: #eef4fb; }
  .dsv-tab input[type=radio] { margin: 0; }
  .dsv-nowrap { white-space: nowrap; }
  .dsv-sub { display: block; color: #8a939c; font-size: 11px; }
  .dsv-cel-nome { max-width: 260px; }
  .dsv-cel-nome div, .dsv-cel-compl div { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #1c2024; }
  .dsv-cel-nome small { display: block; color: #8a939c; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-cel-compl { max-width: 220px; }
  .dsv-cel-compl div { color: #5b6570; }
  .dsv-dir { text-align: right; white-space: nowrap; }
  .dsv-det-cab { display: flex; justify-content: space-between; gap: 10px; font-size: 15px; color: #1c2024; margin-bottom: 10px; }
  .dsv-dl { margin: 0; font-size: 12.5px; }
  .dsv-dl dt { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; margin-top: 8px; }
  .dsv-dl dd { margin: 1px 0 0; color: #1c2024; word-break: break-word; }
  .dsv-dl dd small { color: #6b747e; }
  .dsv-secao { margin-top: 14px; }
  .dsv-secao h5 { margin: 0 0 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; }
  .dsv-rat { border: 1px solid #e6eaee; background: #fff; border-radius: 5px; padding: 6px 8px; margin-bottom: 6px; }
  .dsv-linha { display: flex; justify-content: space-between; gap: 10px; font-size: 12.5px; color: #1c2024; }
  .dsv-rat-l2 { display: flex; justify-content: space-between; gap: 10px; font-size: 11.5px; color: #6b747e; margin-top: 2px; min-width: 0; }
  .dsv-linha-txt { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-rodape { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid #e6eaee; flex: 0 0 auto; }
  .dsv-cont { margin-right: auto; font-size: 12px; font-weight: 600; color: #6b747e; padding: 5px 9px; border-radius: 5px; }
  .dsv-rodape-card .dsv-cont { margin-right: 0; }
  .dsv-ok { background: #eef4fb; color: #2b6cb0; }
  .dsv-bate { background: #e8f5ef; color: #0a6d4d; }
  .dsv-falta { background: #fbeeee; color: #a13c3c; }
  .dsv-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 6px 18px; font-size: 12.5px; font-weight: 600; color: #a13c3c; }
  .dsv-sair:hover { background: #fbe6e6; }

  @media (max-width: 860px) {
    .dsv-corpo { flex-direction: column; overflow: auto; }
    .dsv-lista { overflow: visible; }
    .dsv-detalhe { flex: none; border-left: none; border-top: 1px solid #eef1f4; }
    .dsv-tab-linhas { display: block; overflow-x: auto; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/DevolucaoSolicitacaoVinculo.vue